/**
 * @generated SignedSource<<e23e29c1191c887f8f97413270cca549>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutTrackingActions_transaction$data = {
  readonly isAutomatedOffer: boolean | null;
  readonly isPrivateOffer: boolean | null;
  readonly mostRecentOffer: {
    readonly amountPerItem: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
    readonly quantity: number | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "checkoutTrackingActions_transaction";
};
export type checkoutTrackingActions_transaction$key = {
  readonly " $data"?: checkoutTrackingActions_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTrackingActions_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTrackingActions_transaction"
};

(node as any).hash = "38f1d9c654f368544327ced5d05460ea";

export default node;
